import { sizeOptionsOrDefault } from './utils';
import { MultiPathShape } from './MultiPathShape';
/**
 * Represents a Summing Junction shape, used in control system diagrams to indicate
 * mathematical operations like addition or subtraction. Extends MultiPathShape with
 * a circular path containing cross lines.
 */
export class SummingJunction extends MultiPathShape {
    /**
     * @hidden
     * Draws the summing junction shape path as a circle with intersecting lines.
     */
    _drawPath() {
        const drawingElement = this.drawingElement;
        const { width, height } = sizeOptionsOrDefault(this.options);
        const cx = width / 2;
        const cy = height / 2;
        const radius = Math.min(width, height) * 0.5;
        const topY = cy - radius;
        const bottomY = cy + radius;
        const x1 = cx - radius / Math.SQRT2;
        const y1 = cy - radius / Math.SQRT2;
        const x2 = cx + radius / Math.SQRT2;
        const y2 = cy + radius / Math.SQRT2;
        drawingElement
            .moveTo(cx, topY)
            .arcTo([cx, bottomY], radius, radius, false, true)
            .arcTo([cx, topY], radius, radius, false, true)
            .moveTo(x1, y1)
            .lineTo(x2, y2)
            .moveTo(x2, y1)
            .lineTo(x1, y2);
    }
}
